<template>
  <div>
<v-btn 
rounded 
:text="text" 
dark 
:fab="fab"
:color="color" 
:small="small" 
:x-small="xsmall" 
:large="large" 
:x-large="xlarge" 
@click="buttonClicked()" 
:disabled="disabled"
:href="href"
>
    <v-icon :left="fab?false:true">{{ icon }}</v-icon> {{ fab? '':label }}
</v-btn>
  </div>
</template>

<script>

export default {
    props: {
        color: {
            default: 'blue'
        },
        icon: {
            default: 'mdi-vuetify'
        },
        label: {
            default: 'Button'
        },
        data: {
            default: null
        },
        small: {
            default: true
        },
        xsmall: {
            default: false
        },
        large: {
            default: false
        },
        xlarge: {
            default: false
        },
        disabled: {
            default: false
        },
        text: {
            default: false
        },
        href: {
            default: '#'
        },
        fab: {
            default: false
        }
    },
    methods: {
        buttonClicked() { 
            this.$emit('button-clicked',this.data)
        }
    }
}
</script>

<style>

</style>